import React from 'react'
import SizeSelector from '../SizeSelector'
class TieupSizePanel extends React.Component {

    render() {
        return (
            <span>
                <h2>{this.props.prompt}</h2>
                <SizeSelector onChangeFunction={this.props.tieupShaftsChangedFunction} prompt='Tieup&nbsp;Shafts:&nbsp;' />
                <SizeSelector onChangeFunction={this.props.tieupTreadlesChangedFunction} prompt='Tieup&nbsp;Treadles:&nbsp;' />
            </span>)
    }
}

export default TieupSizePanel


// WEBPACK FOOTER //
// ./src/scenes/reducer/components/TieupSizePanel/index.js